module.exports = (value) =>
  Array.isArray(value) ? value.length === 0 : value === '';
